import _core from "./core";
import _cipherCore from "./cipher-core";
var exports = {};
;

(function (root, factory, undef) {
  // CommonJS
  exports = exports = factory(_core, _cipherCore);
})(exports, function (CryptoJS) {
  /**
   * A noop padding strategy.
   */
  CryptoJS.pad.NoPadding = {
    pad: function () {},
    unpad: function () {}
  };
  return CryptoJS.pad.NoPadding;
});

export default exports;